<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()

  /**
   * @type {Array} list of font family names
   */
  let dropdownItems = ["Mark Emails as sent"]
  /**
   * @type {boolean} toggling the dropdown to show and hide
   */
  let showDropdown = false

  /**
   * @type {undefined} binded the overall dropdown parent element
   */
  let dropdown
  /**
   * function to close the dropdown on click anywhere in window
   * @param e-targetting binded value to close drop down
   */
  const onCloseDropDown = (e) => {
    if (dropdown.contains(e.target) == false) showDropdown = false
  }
</script>

<svelte:window on:click={onCloseDropDown} />
<div class="w-max" bind:this={dropdown}>
  <div class="flex h-9 rounded-md border border-[#a0a1a580] bg-blue-500 text-sm font-medium text-white">
    <button on:click type="button" class="flex h-9 items-center px-3">
      <span><i class="fa-solid fa-envelope" /></span>
      &nbsp;&nbsp;&nbsp;
      <span class="hidden select-none sm:block">Send Email for documents</span>
    </button>

    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      on:click|stopPropagation={() => {
        showDropdown = !showDropdown
      }}
      class="flex aspect-square cursor-pointer items-center justify-center text-sm text-white"
    >
      <i class="fa-solid fa-chevron-down {showDropdown ? 'rotate-180' : 'rotate-0'}" />
    </div>
  </div>
  <ul style="padding-inline-start:0px;" class:hidden={!showDropdown} class="absolute left-0 z-10 mt-1 max-h-56 w-full flex-col overflow-auto rounded-md border border-[#a0a1a580] bg-white text-base shadow-lg ring-opacity-5 focus:outline-none dark:bg-darkgray sm:text-sm" tabindex="-1">
    {#each dropdownItems as item}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <li
        on:click={() => {
          dispatch("change")
        }}
        class="relative cursor-pointer select-none rounded-md p-2 text-center text-gray-d00 hover:bg-yellow-500 hover:text-white dark:text-white hover:dark:text-black xl:pl-9"
      >
        <!-- dark:hover:bg-black -->
        <div class="flex items-center">
          <div class="text-sm">{item}</div>
        </div>
      </li>
    {/each}
  </ul>
</div>
